import { BCMSDefaultModel, BCMSRecord, Workflow, useGlobalController } from "@bcm-dev/bcms-vite";
import AuthorizedDeviceEnrollmentPage from "components/pages/AuthorizedDeviceEnrollmentPage";
import { MobileDevice } from "model";
import React from "react";

// Steps of the workflow
const steps = [ <AuthorizedDeviceEnrollmentPage /> ];

/**
 * @function AuthorizedDeviceEnrollmentWorkflow
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @exported true
 * @description The workflow component for the "Authorize Device Enrollment" page.
 * 
 * Setting constructor example for state captures:
 * 
 * document.dispatchEvent(new CustomEvent("force-workflow-state", {
        detail: { 
            value: { 
            mobileDevice: {
                name: "some iphone",
                number: "000-000-0000",
                isEnrolled: true
            }
            } 
        } 
    }));
 */
export default function AuthorizedDeviceEnrollmentWorkflow(props) {
    const controller = useGlobalController();
    // Get the inital state of the workflow
    const value = getDefault(controller);
    // Define the constructor function for forcing state through the 'force-workflow-state' event
    const constructor = record => {
        const _defaultValue = getDefault(controller);
        let mobileDeviceObj = record.mobileDevice;
        let mobileDeviceFromObj = MobileDevice.init({ ...mobileDeviceObj });
        let merged = BCMSDefaultModel.mergeRecords(mobileDeviceFromObj, _defaultValue.mobileDevice);
        let mergedMobile = MobileDevice.init({ ...merged });

        return { ..._defaultValue, data: { ..._defaultValue.data, mobile: mergedMobile } };
    };

    // Return the workflow component
    return <Workflow value={ value } steps={ steps } constructor={ constructor } />
}
// Return the steps of the workflow
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @param {Controller} controller - A global controller.
 * @returns {Object}
 * @exported true
 * @description Function to get the default state of the workflow
 */
export const getDefault = controller => {
    BCMSRecord.globalControllerFor([ MobileDevice ], controller);
    // Initalize mobile devices and accounts for the user.
    const mobileDevice = BCMSDefaultModel.mobileDevice();
    mobileDevice.name = "";
    mobileDevice.userID = "";
    mobileDevice.password = "";
    mobileDevice.id = MobileDevice.nextID();
    // Return the default workflow state

    return {
        data: {
            mobile: mobileDevice
        }
    }
};